/* eslint react-hooks/exhaustive-deps: 0 */

import { useEffect, useRef } from 'react';
import { isEqual } from 'lodash';

const useDeepEffect = (fn: any, deps: any[]) => {
  const isFirst = useRef(true);
  const prevDeps = useRef(deps);

  useEffect(() => {
    const isSame = prevDeps.current.every((obj, index) => isEqual(obj, deps[index]));

    if (isFirst.current || !isSame) {
      fn();
    }

    isFirst.current = false;
    prevDeps.current = deps;
  }, deps.concat([fn]));
};

export default useDeepEffect;
